<template>
  <div class="container DDList">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() => $router.replace('/')"
        >首页</a-breadcrumb-item
      >
      <a-breadcrumb-item
        href=""
        @click.native="() => $router.replace('/onlineRegistrationV2')"
        >预约挂号</a-breadcrumb-item
      >
      <a-breadcrumb-item href="" @click.native="() => $router.replace('/DDList')"
        >搜索科室/医生</a-breadcrumb-item
      >
      <a-breadcrumb-item>医生列表</a-breadcrumb-item>
    </a-breadcrumb>

    <a-tabs v-model="activeKey">
      <a-tab-pane :key="item.key" :tab="item.name" v-for="item in tabs"> </a-tab-pane>
    </a-tabs>

    <!--医生列表-->
    <div class="content">
      <a-card
        hoverable
        class="item-card"
        v-for="(item, index) in list"
        :key="index"
        @click="onDetail(item)"
      >
        <img
          v-if="item.headerImg"
          :src="item.headerImg"
          @error="onImgError(index)"
          alt=""
        />
        <img v-else src="@/assets/img/doc.png" alt="" />
        <h3>
          {{ item.ygxm }} <span>{{ item.ygzc }}</span>
        </h3>
        <div class="fontColor">{{ item.ghksmc }}</div>
        <div class="fontColor">{{ item.yqmc }}</div>
      </a-card>
    </div>
    <a-empty v-if="isNo" />
  </div>
</template>

<script>
import { queryResourceInfo } from "@/api/registration";
import base from "@/assets/base/base.js";
export default {
  data() {
    return {
      searchLoading: false,
      isNo: false,
      searchText: "",
      activeKey: "1",
      tabs: [{ key: "1", name: "医生列表" }],
      list: [],
    };
  },

  methods: {
    onImgError(i) {
      this.list[i].headerImg = require("@/assets/img/doc.png");
    },
    //获取医生数据
    async getDoctorData() {
      const params = {
        mzks: this.$route.query.mzks, //科室编号
        qssj: this.dateList[0], //起始时间
        jssj: this.dateList[this.dateList.length - 1], //结束时间
      };
      const { code, data } = await queryResourceInfo(params);
      this.searchLoading = false;
      if (code == 200) {
        if (data.length > 0) {
          this.list = data;
        } else {
          this.isNo = true;
        }
      }
    },

    searchData() {
      this.searchLoading = true;
      this.isNo = false;
      this.list = [];
      this.getDoctorData();
    },

    onDetail(data) {
      this.$router.push({
        path: "/doctorDetailV2",
        query: { data: JSON.stringify(data) },
      });
    },
  },
  created() {
    this.dateList = base.getSevenYMD(new Date());
    this.searchData();
  },
  beforeDestroy() {
    this.$notification.destroy();
  },
};
</script>

<style lang="scss" scoped>
.container {
  .date-select {
    padding: 20px;
    margin-bottom: 20px;
    width: 100%;
    border-radius: 4px;
    background: #f8f8f8;
    .ant-space-item {
      width: 100%;
    }

    .date-label {
      font-size: 16px;
    }

    .activedDay {
      color: #fff;
      background-color: #3f86ff;
    }
  }

  .select {
    .title {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      padding-right: 30px;

      h3 {
        font-size: 20px;
      }

      .line {
        width: 100px;
        height: 2px;
        background: #000;
      }
    }
  }

  .select-box {
    display: flex;
    justify-content: center;
    padding: 20px 0;

    h3 {
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: #f8f8f8;
      font-size: 16px;
      font-weight: 400;
      color: #999999;
    }

    .select-hospital {
      flex: 3;
      border: 1px solid #f8f8f8;

      .hospital-item {
        cursor: pointer;
        height: 50px;
        box-sizing: border-box;
        font-size: 16px;
        text-align: center;
        line-height: 50px;
      }
    }

    .select-department {
      flex: 5;
      border: 1px solid #f8f8f8;
      padding: 0 16px;
    }

    .department-content {
      height: 500px;
      overflow-y: auto;
      overflow-x: hidden;
    }

    .select-doctor {
      flex: 4;
      cursor: pointer;
      box-sizing: border-box;
      font-size: 16px;
      border: 1px solid #f8f8f8;
      margin-left: -1px;

      .list-item {
        display: flex;
        padding: 16px;
        align-items: center;
        border-bottom: 1px solid #f8f8f8;
        cursor: pointer;

        img {
          text-align: center;
          width: 80px;
          height: 80px;
          margin-right: 12px;
          border-radius: 50%;
          border: 1px solid #f8f8f8;
        }

        .list-pro-name {
          .item-name {
            margin: 2px 0;
          }

          .item-name {
            font-size: 14px;

            &-text {
              font-size: 22px;
              color: #333;
              font-weight: 600;
            }

            &-job {
              color: #333;
              padding: 0 10px;
            }

            &-tf {
              padding: 1px 4px;
              color: #3f86ff;
              border: 1px solid #3f86ff;
              border-radius: 2px;
              margin-right: 4px;
            }
          }

          .item-department-name {
            margin-top: 4px;
            color: #666;
          }

          .item-skilled {
            margin-top: 4px;
            width: 65%;
            color: #666;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }

  .actived,
  .activedDepartmentStyle {
    font-weight: bold;
    background-color: rgba(63, 134, 255, 0.07) !important;
  }
}

.content {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  .item-card {
    width: 220px;
    margin: 0 7px;
    text-align: center;
    margin-bottom: 15px;
    img {
      height: 60px;
      width: 60px;
      border-radius: 50%;
      margin-bottom: 10px;
      background-color: #eee;
    }

    h3 {
      text-align: center;
      font-size: 16px;
      span {
        font-size: 14px;
        color: #666;
      }
    }

    .fontColor {
      font-size: 14px;
      text-align: center;
      color: #a9a9a9;
    }
  }
}
</style>
